<template>
  <div
    class="production-shell app-shell"
    :style="{
      marginTop: headerHeight + 'px',
      minHeight: 'calc(100vh - ' + headerHeight + 'px)'
    }"
  >
    <div
      class="production-sidebar app-sidebar"
      :style="{ top: headerHeight + 'px' }"
    >
      <el-menu
        class="production-menu"
        :default-active="section"
        background-color="transparent"
        @select="selectSection"
      >
        <el-menu-item v-if="p('Production.Monitoring.View')" index="monitoring">
          <i class="el-icon-data-line"></i>
          <span slot="title">Monitoring</span>
        </el-menu-item>
        <el-menu-item
          v-if="p('Production.Test Reports.View')"
          index="test_reports"
        >
          <i class="el-icon-tickets"></i>
          <span slot="title">Test Reports</span>
        </el-menu-item>
        <el-menu-item
          v-if="p('Production.Acceptance Criteria.View')"
          index="acceptance_criteria"
        >
          <i class="el-icon-finished"></i>
          <span slot="title">Acceptance Criteria</span>
        </el-menu-item>
        <el-menu-item
          v-if="p('Production.Firmware & Software.View')"
          index="firmware"
        >
          <i class="el-icon-cpu"></i>
          <span slot="title">Firmware</span>
        </el-menu-item>
      </el-menu>
    </div>

    <div class="production-main app-main">
      <div class="production-page">
        <AppBreadcrumb
          root="Production"
          :current="sectionTitle"
          @root-click="selectSection('monitoring')"
        />

        <Monitoring v-if="section === 'monitoring'" />
        <TestReports v-if="section === 'test_reports'" />
        <AcceptanceCriteria v-if="section === 'acceptance_criteria'" />
        <Firmware v-if="section === 'firmware'" />
      </div>
    </div>
  </div>
</template>

<script>
import Monitoring from '@/components/production/pod/Monitoring'
import TestReports from '@/components/production/pod/TestReports'
import AcceptanceCriteria from '@/components/production/pod/AcceptanceCriteria'
import Firmware from '@/components/production/pod/Firmware'
import headerHeight from '@/mixins/headerHeight'
import AppBreadcrumb from '@/components/AppBreadcrumb'

const SECTION_TITLES = {
  monitoring: 'Monitoring',
  test_reports: 'Test Reports',
  acceptance_criteria: 'Acceptance Criteria',
  firmware: 'Firmware'
}

export default {
  mixins: [headerHeight],
  data() {
    return {
      section: 'monitoring'
    }
  },
  components: {
    Monitoring,
    TestReports,
    AcceptanceCriteria,
    Firmware,
    AppBreadcrumb
  },
  computed: {
    sectionTitle() {
      return SECTION_TITLES[this.section] || ''
    }
  },
  mounted() {
    if (this.$permission('Production.Monitoring.View')) {
      this.section = 'monitoring'
    } else if (this.$permission('Production.Test Reports.View')) {
      this.section = 'test_reports'
    } else if (this.$permission('Production.Acceptance Criteria.View')) {
      this.section = 'acceptance_criteria'
    } else {
      this.section = 'firmware'
    }
  },
  methods: {
    selectSection(section) {
      this.section = section
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';

.production-page {
  flex: 1;
  padding: 20px 24px;

  // The child components (Monitoring/TestReports/AcceptanceCriteria/
  // Firmware) each render their own `.page-title` heading, now redundant
  // with the breadcrumb above — hidden via CSS rather than editing four
  // separate files for one heading each. Table look is unified globally in
  // global.scss (.el-table), no per-module override needed here.
  /deep/ .page-title {
    display: none;
  }
}
</style>
